export const API_URL = 'https://api.marinehub.eu';
